// base rc-tabs 11.12.0
import Tabs from './Tabs';
import TabPane from './TabPanelList/TabPane';
export { TabPane };
export default Tabs;
